import Clock from '@components/Clock';
import { Box } from '@fastly/consistently';
import * as React from 'react';
import styled from 'styled-components';
import Logo from '../images/dept-of-know.svg';
import PoweredByLogo from '../images/power-by-fastly.svg';

const EventLogo = styled(Logo)`
  width: auto;
  height: 35px;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 60px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    height: 72px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 100px;
  }
`;

const FastlyLogo = styled(PoweredByLogo)`
  justify-self: end;
`;

const Header = (): JSX.Element => {
  return (
    <Box
      as="header"
      display="grid"
      gridTemplateColumns={{ _: 'repeat(2, 1fr)', md: 'auto 1fr auto' }}
      alignItems="center"
      gridGap="16px"
      py={16}
      px={{ _: 32, xl: 50 }}
      height={{ _: 'auto', md: 140, lg: 180, xl: 200 }}
    >
      <EventLogo />
      <Clock />
      <Box as="a" href="https://www.fastly.com" target="_blank" justifySelf="end">
        <FastlyLogo />
      </Box>
    </Box>
  );
};

export default Header;
